import { Grid, useMediaQuery } from "@material-ui/core";
import Table from "components/Table";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Cell } from "react-table";
import { RootState } from "redux/rootReducer";
import { getReportDateSelector } from "redux/user/user";
import { loadYieldListByAssetClass } from "redux/yieldList/yieldListFunctions";
import { asEur } from "utility/numbers";
import { YieldList } from "types/YieldList";
import { AssetClass } from "types/AssetClass";

interface Props {
  assetClass: AssetClass;
}

const YieldListTable = (props: Props) => {
  const { assetClass } = props;

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 960px)");

  const reportControlId = useSelector(
    (state: RootState) => state.user.reportControlId
  );
  const reportDate = useSelector(getReportDateSelector);

  const yieldList = useSelector(
    (state: RootState) =>
      state.yieldList[AssetClass[assetClass] as keyof typeof AssetClass]
        ?.data ?? []
  );
  const yieldListLoading = useSelector(
    (state: RootState) =>
      state.yieldList[AssetClass[assetClass] as keyof typeof AssetClass]
        ?.loading
  );

  React.useEffect(() => {
    if (reportControlId && reportDate) {
      dispatch(
        loadYieldListByAssetClass(assetClass, reportControlId, reportDate)
      );
    }
  }, [dispatch, reportControlId, reportDate, assetClass]);

  const yieldListFooterItem = yieldList.find(
    (x) => x.Salkku === "Kokonaistuotto"
  );

  const yieldListColumns = [
    {
      Header: "",
      accessor: "Salkku",
      whiteSpace: "nowrap",
      paddingRight: "10px",
      Footer: yieldListFooterItem?.Salkku ?? "",
    },
    {
      Header: t("start"),
      accessor: "Alusta",
      whiteSpace: "nowrap",
      paddingRight: "10px",
      Cell: (cell: Cell<YieldList, number>) =>
        asEur(cell.value, undefined, true),
      textAlign: "right",
      fontFamily: "Lato light",
      Footer: asEur(yieldListFooterItem?.Alusta, undefined, true),
    },
    {
      Header: t("ytd"),
      accessor: "YTD",
      whiteSpace: "nowrap",
      paddingRight: "10px",
      Cell: (cell: Cell<YieldList, number>) =>
        asEur(cell.value, undefined, true),
      textAlign: "right",
      fontFamily: "Lato light",
      Footer: asEur(yieldListFooterItem?.YTD, undefined, true),
    },
    {
      Header: t("month"),
      accessor: "Kuukausi",
      whiteSpace: "nowrap",
      Cell: (cell: Cell<YieldList, number>) =>
        asEur(cell.value, undefined, true),
      textAlign: "right",
      fontFamily: "Lato light",
      Footer: asEur(yieldListFooterItem?.Kuukausi, undefined, true),
    },
  ];

  return (
    <Grid
      item
      md={6}
      sm={12}
      style={{
        padding: matchesMediaQuery ? "0 16px 16px 0" : "0 16px 16px 16px",
        overflowY: "hidden",
      }}
    >
      <Table
        data={yieldList.filter((x) => x.Salkku !== "Kokonaistuotto")}
        columns={yieldListColumns}
        hasFooter
        loading={yieldListLoading}
      />
    </Grid>
  );
};

export default React.memo(YieldListTable);
